import { SIN_CATEGORIA } from "../constants/constants"

const mapArticulosToSendApi = ({
  articulosSelected,
  articulosByCategoria,
}: $TSMigrationFixMe) => {
  const categoriasId: $TSMigrationFixMe = []
  const articulosId = []

  Object.keys(articulosSelected).forEach((categoriaName) => {
    const { articulos = [] } = articulosSelected?.[categoriaName] || {}
    const { totalCount, categoriaId } =
      articulosByCategoria?.[categoriaName] || {}
    if (!categoriaId) return

    if (totalCount === articulos.length) categoriasId.push(categoriaId)
    else articulosId.push(...articulos.map(({ id }: $TSMigrationFixMe) => id))
  })

  if (Array.isArray(articulosSelected[SIN_CATEGORIA]?.articulos)) {
    articulosId.push(
      ...articulosSelected[SIN_CATEGORIA].articulos.map(
        ({ id }: $TSMigrationFixMe) => id
      )
    )
  }

  return { categoriasId, articulosId }
}

export default mapArticulosToSendApi
